<template>
    <!-- 长者删除 -->
    <div class="leave">
      <table-base
        :tableData="dataList"
        @page-change="pageChange"
        @currentpage-change="clickChange"
        :loading="tableloading"
        :len="tabelLen"
        :pageNum="requestParams.pageNo"
        :pageName="AcurrentPage"
        :titleStyle="titleStyle"
      >
        <template slot="header">
          <el-form
            :inline="true"
            class="header-nowrap toolbar"
            style="padding-bottom: 0px"
          >
            <el-row>
              <el-form-item label="老人姓名">
                <el-input
                  v-model.trim="input_name"
                  @keydown.native="enterSearch"
                  clearable
                  placeholder="老人姓名"
                ></el-input>
              </el-form-item>
             
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  style="margin-left:40px"
                  plain
                  @click.native="tableSearch"
                  >查询</el-button
                >
              </el-form-item>
            </el-row>
          </el-form>
        </template>
        <template slot="table">
          <el-table-column
            prop="oldName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="oldAge"
            label="年龄"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="oldIdCard"
            label="身份证号码"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="oldAge"
            label="身份证号"
            align="center"
          ></el-table-column>
          <el-table-column prop="cardAddress" label="街道社区" align="center" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="oldAddress" label="家庭住址" align="center" min-width="210" show-overflow-tooltip></el-table-column>

          <el-table-column
            label="操作"
            class-name="operator"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                @click="handlePayment(scope.$index, scope.row)"
                type="warning"
                style="padding: 3px 12px"
                plain
                :disabled="scope.row.disabledFlag"
                >迁出</el-button
              >
              <!-- <el-button
                @click="handleDetail(scope.$index, scope.row)"
                type="primary"
                style="padding: 3px 12px"
                plain
                >详情</el-button
              > -->
            </template>
          </el-table-column>
        </template>
      </table-base>
  
      <el-dialog
        :visible.sync="dialogFormVisible"
        width="400px"
        center
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title">迁出办理</div>
        <el-form :model="totalFee">
          
          <el-form-item label="老人姓名:">
            <span>
              <i class="Fee">{{ totalFee.oldName }}</i>
            </span>
          </el-form-item>
          <el-form-item label="老人身份证号:">
            <span>
              <i class="Fee">{{ totalFee.oldIdCard }}</i>
            </span>
          </el-form-item>
        </el-form>
  
        <div slot="footer" class="dialog-footer" style="margin-top: 50px">
          <el-button type="primary" @click.stop="leaveSubmit">确 定</el-button>
          <el-button type="warning" @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script type="text/javascript">
  import TableBase from "@/components/common-table.vue";
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  import util from "@/utils/util.js";
  export default {
    components: { TableBase },
    data() {
      return {
        tableloading: false,
        input_name: "",
        oldIdCard: "",
        select_value: "",
        dataList: [],
        tabelLen: 0,
        requestParams: {
          oldName: "",
          minTime: "",
          maxTime: "",
          pageNo: "1",
          pageSize: "10",
        },
        AcurrentPage: "leavelist-page",
        titleStyle: "background-color:#bee1f4;color:#6f7075;font-weight: 700;",
        dateValue: "",
        dialogFormVisible: false,
        totalFee: {},
        rowData: {},
        disabledFlag: false,
        pickerLeaveDate: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      };
    },
    methods: {
      /* 
        enter键查询
      */
      enterSearch(e) {
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13) {
          this.getLeaveList();
          this.fromFirstPageSearch();
        }
      },
  
      /* 
        点击从第一页开始查询
      */
      fromFirstPageSearch() {
        this.pageNo = "1";
        this.$nextTick(() => {
          var pageArray = document.querySelector(".el-pager");
          var num = Number(this.pageNo) - 1;
          console.log(pageArray);
          pageArray && pageArray.children[num].click();
        });
      },
  
      /* 
        查询按钮查询
      */
      tableSearch() {
        this.getLeaveList();
      },
  
      /* 
        刷新 
      */
      handleNew() {
        this.getLeaveList();
      },
  
      /* 
        分页点击
      */
      clickChange(val) {
        console.log(val);
        // 等待DOM渲染完毕在JS点击，这里的点击不能放在基本组件中使用，组件是从内到外的渲染，外层是初始值
        setTimeout(function () {
          var pageArray = document.querySelector(".el-pager");
          console.log(pageArray);
          var num = Number(val) - 1;
          pageArray && pageArray.children[num].click();
        }, 500);
      },
  
      /* 
        分页页码的改变
      */
      pageChange(val) {
        console.log(val);
        this.requestParams.pageNo = val + "";
        this.getLeaveList();
      },
  
      /* 
        日期时间选择器
      */
      dateChange(data) {
        if (data) {
          console.log(data);
          var minTime = util.formatDate.format(data[0], "yyyy-MM-dd hh:mm:ss");
          var maxTime = util.formatDate.format(data[1], "yyyy-MM-dd hh:mm:ss");
          this.requestParams.minTime = minTime;
          this.requestParams.maxTime = maxTime.substring(0, 10) + " 23:59:59";
        } else {
          this.requestParams.minTime = "";
          this.requestParams.maxTime = "";
        }
      },
  
      /* 
        获取出院表格的分页的数据
      */
      getLeaveList() {
        var name = this.input_name.trim();
        var oldIdCard = this.oldIdCard.trim();
        let param = {
          oldName: name,
          oldIdCard: oldIdCard,
          pageNo: this.requestParams.pageNo,
          serviceType:0,
          pageSize: this.requestParams.pageSize,
        };
        this.tableloading = true;
        this.$postJson(
          "omc/Oldman/quickShowAllOldMan",
          param
        ).then((res) => {
          this.tableloading = false;
          if (res.status || res.code == 200) {
            this.tabelLen = +res.result.total;
            this.dataList = res.result.list;
            var list = this.dataList;
            list.forEach((data) => {
              this.transformLeaveItem(data);
            });
          }
        });
      },
  
      /* 
        处理数据显示
      */
      transformLeaveItem(data) {
        data.sex = data.sex == 0 ? "男" : "女";
        if (data.leaveDate) {
          data.leaveDate = data.leaveDate.split(" ")[0];
        }
      },
  
      /* 
        表格的结算按钮
      */
      handlePayment(index, row) {
        console.log(row);
        this.rowData = row;
        var id = Number(this.rowData.oldmanId);
        // this.getPaymentShow(id);
        console.log(id);
        this.totalFee.oldName = row.oldName;
        this.totalFee.oldIdCard = row.oldIdCard;
        this.dialogFormVisible = true;
      },
  
      /* 
        结算弹框的数据回显
      */
      // getPaymentShow(id) {
      //   let oldmanId = id;
      //   console.log(oldmanId);
      //   this.$postForm(
      //     "omc/OldmanLeave/getSettleDetailByOldmanId/" + oldmanId
      //   ).then((res) => {
      //     console.log(res);
      //     if (res.status || res.code == 200) {
      //       this.totalFee.oldName = res.result.oldName; //老人姓名
      //       this.totalFee.pledge = res.result.pledge; //入院金额
      //       this.totalFee.deposited = res.result.deposited; //预缴费用
      //       this.totalFee.actPaidFee = res.result.actPaidFee; //实缴费用
      //       this.totalFee.monetary = res.result.monetary; //消费金额
      //       this.totalFee.remainder = res.result.remainder; //余额
      //       this.totalFee.balance = res.result.balance; //结算金额
      //       this.totalFee.recharge =
      //         res.result.recharge == null ? 0 : res.result.recharge; //充值金额
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //     this.dialogFormVisible = true;
      //     console.log(this.totalFee);
      //   });
      // },
      /* 
        出院详情
      */
      handleDetail(index, row) {
        sessionStorage.setItem("oldManId",row.oldmanId);
        bus.$emit("homePage", {
            type: "jump",
            path: "/leaveDetail",
            title: "出院详情",
          });
      },
  
      /* 
        结算弹框点击
      */
      leaveSubmit() {
        this.leaveConfirm();
      },
  
      /* 
        结算弹框提交数据
      */
      leaveConfirm() {
        let oldmanId = this.rowData.oldmanId;
        console.log(oldmanId);
        this.$postForm("omc/OldmanLeave/residentLeave/" + oldmanId).then(
          (res) => {
            console.log(res);
            if (res.code == 200) {
              // this.$message.success('成功出院')  by guo 2019-4-9 /*注释掉*/
              // 出院后更新状态
              // var params = {
              //   oldmanId: this.rowData.oldmanId,
              //   status: 4
              // };
              //this.updateAdmissionStatus(params);
              //by guo 2020-7-29-16:31 修改   修复社区版出院的问题
              this.$message.success("成功迁出");
              this.getLeaveList(); //刷新列表数据
              // 状态更新后弹出层消失
              this.dialogFormVisible = false;
  
              // setTimeout(() => {
              //   this.$message.success("成功出院");
              // }, 1000);
            } else {
              this.$message.error(res.message);
            }
          }
        );
      },
  
      /* 
        更新老人的状态
      */
      updateAdmissionStatus(params) {
        this.$postForm("omc/Oldman/changeOldStatus", params).then((res) => {
          console.log(res);
          if (res.status || res.code == 200) {
            this.getLeaveList(); //刷新列表数据
            // 状态更新后弹出层消失
            this.dialogFormVisible = false;
          }
        });
      },
    },
    created() {
      this.getLeaveList();
    },
  };
  </script>
  <style lang="scss" scoped>
  .leave {
    .header-nowrap {
      white-space: nowrap;
    }
    .payment {
      color: #3f7be2;
      margin-right: 20px;
    }
    .detail {
      color: #318f11;
    }
    // .el-button--mini {
    //   margin-left: 3px;
    //   padding: 0px;
    //   border: 0;
    //   font-size: 14px;
    // }
    .el-dialog__wrapper {
      ::v-deep .el-dialog__header {
        background: #cccccc3d;
        border-bottom: 1px solid #ddd;
      }
      .el-form-item {
        margin-bottom: 0px;
        ::v-deep .el-form-item__label {
          width: 45%;
        }
        ::v-deep .el-form-item__content {
          margin-left: 56%;
        }
        .Fee {
          font-weight: 700;
          color: #166ad0;
          font-size: 15px;
          height: 40px;
          line-height: 40px;
        }
      }
    }
    .btnWdith {
      width: 76px;
    }
  }
  .shijiao:hover::after {
    content: attr(data-title); //取到data-title属性的值
    display: inline-block;
    padding: 10px 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    position: absolute;
    width: 80px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    top: -40px;
    left: -70px;
    font-size: 12px;
    background: #000;
    opacity: 0.7;
    color: rgb(223, 207, 207);
  }
  .yue:hover::after {
    content: attr(data-title); //取到data-title属性的值
    display: inline-block;
    padding: 10px 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    position: absolute;
    width: 350px;
    height: auto;
    line-height: auto;
    text-align: left;
    top: 16px;
    left: -80px;
    font-size: 12px;
    background: #000;
    opacity: 0.7;
    color: rgb(223, 207, 207);
  }
  .beizhu:hover::after {
    content: attr(data-title); //取到data-title属性的值
    display: inline-block;
    padding: 10px 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    position: absolute;
    width: 320px;
    height: auto;
    line-height: 5px;
    text-align: left;
    top: 16px;
    left: -80px;
    font-size: 12px;
    background: #000;
    opacity: 0.7;
    color: rgb(223, 207, 207);
  }
  //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
  </style>
  